import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { StyledEngineProvider } from '@mui/material/styles';
import 'bootstrap/dist/css/bootstrap.css';

ReactDOM.render(
  <StyledEngineProvider injectFirst>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </StyledEngineProvider>,
  document.getElementById('root')
);

